import { action, makeAutoObservable, runInAction } from "mobx"
import { Menu, MenuType } from "../../services/menu/models";
import { getAliasBinding } from "../../services/aliases/rest";
import MenuRestService from "../../services/menu/rest";


class GeneralMenuViewStore {
    scroll: boolean = false;
    //@ts-ignore
    menu: Menu = null;
    menus: { [s: string]: Menu } = {};
    type: MenuType = MenuType.none;


    isModifiersPopupVisible: boolean = false;
    isCategoryMenuVisible: boolean = false;
    isDetailsModalVisible: boolean = false;
    isCartModalVisible: boolean = false;
    isOverlayOpen: boolean = false;
    isLangsModalOpen: boolean = false;

    onOverlayClick?: () => void;


    constructor() {
        makeAutoObservable(this);
    }


    @action
    setMenu (menu: Menu) {
        this.menu = menu;
    }


    @action
    setMenuType (type: MenuType) {
        this.type = type;
    }


    @action
    resetScroll() {
        this.scroll = false;
    }


    @action
    openCategoryMenu(onOverlayClick: () => void) {
        this.isCategoryMenuVisible = true;
        this.isOverlayOpen = true;
        this.onOverlayClick = onOverlayClick;
        document.body.style.overflow = 'hidden';
    }

    @action
    closeCategoryMenu() {
        this.isCategoryMenuVisible = false;
        this.isOverlayOpen = false;
        this.onOverlayClick = undefined;
        document.body.style.overflow = 'auto';
    }

    @action
    closeCartModal() {
        this.isCartModalVisible = false;
        this.isOverlayOpen = false;
        this.onOverlayClick = undefined;
        document.body.style.overflow = 'auto';
    }

    @action
    openInfoDetailesModal(onOverlayClick: () => void) {
        this.isDetailsModalVisible = true;
        this.isOverlayOpen = true;
        this.onOverlayClick = onOverlayClick;
        document.body.style.overflow = 'hidden';
    }

    @action
    closeInfoDetailesModal() {
        this.isDetailsModalVisible = false;
        this.isOverlayOpen = false;
        this.onOverlayClick = undefined;
        document.body.style.overflow = 'auto';
    }

    @action
    openLangsModal(onOverlayClick: () => void) {
        this.isLangsModalOpen = true;
        this.isOverlayOpen = true;
        this.onOverlayClick = onOverlayClick;
        document.body.style.overflow = 'hidden';
    }

    @action
    closeLangsModal() {
        this.isLangsModalOpen = false;
        this.isOverlayOpen = false;
        this.onOverlayClick = undefined;
        document.body.style.overflow = 'auto';
    }


    async getMenuByAlias(alias: string, menuId: number) {
        const res = await getAliasBinding(alias);

        if (!res) return;

        runInAction(() => {
            this.menus = Object.values(res.menusByOrgBranchIdByMenuId).reduce((memo, items) => {
                return {
                    ...memo,
                    ...items
                }
            });
            this.menu = this.menus[menuId]
        })
    }
    async getMenuTypeByMenuId(menuId: number) {
        const menu = await MenuRestService.getMenuInfo(menuId);

        runInAction(() => {
            if (menu) {
                this.type = menu.type
            }
        })
    }
}

export default GeneralMenuViewStore;
